module.exports = __webpack_public_path__ + "img/sweden.61d447c4.svg";